import React from 'react';
import { X, Gift, Star } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { hideReward } from '../../features/ui/uiSlice';

const RewardModal = () => {
  const dispatch = useDispatch();
  const { modals, rewardData } = useSelector((state) => state.ui);
  const isOpen = modals.reward;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-md shadow-xl border border-blue-100">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex items-center space-x-2">
            <Gift size={20} className="text-blue-600" />
            <h3 className="text-lg font-bold text-gray-900">Congratulations!</h3>
          </div>
          <button
            onClick={() => dispatch(hideReward())}
            className="p-2 text-gray-500 hover:text-gray-700"
          >
            <X size={18} />
          </button>
        </div>
        <div className="p-6 text-center space-y-3">
          <div className="mx-auto w-16 h-16 rounded-full bg-yellow-50 border border-yellow-100 flex items-center justify-center">
            <Star size={28} className="text-yellow-500" />
          </div>
          <div>
            <p className="text-gray-900 font-semibold">
              {rewardData?.title || 'You earned points!'}
            </p>
            <p className="text-gray-600 mt-1">
              {rewardData?.message || 'Keep it up and earn more by exploring features.'}
            </p>
          </div>
          {typeof rewardData?.points === 'number' && (
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-purple-50 border border-purple-200 text-purple-800 font-medium">
              +{rewardData.points} points
            </div>
          )}
        </div>
        <div className="p-4 border-t border-gray-100 text-center">
          <button
            onClick={() => dispatch(hideReward())}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 font-medium"
          >
            Awesome!
          </button>
        </div>
      </div>
    </div>
  );
};

export default RewardModal;


